import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GamePage from './components/GamePage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/:gameId" element={<GamePage />} />
          <Route path="*" element={<div style={{color: 'white', padding: '20px', textAlign: 'center'}}>Pagina non trovata</div>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
